import { ROUTES } from '@shared/config/routes'

export interface AssistantService {
  id: string
  /** Подпись под иконкой — короткая, помещается в две строки. */
  label: string
  /** Иконка Iconify, как в нижнем меню. */
  icon: string
  path: string
  /** Фон плитки: у каждого сервиса свой, чтобы отличать их с одного взгляда. */
  color: string
}

/**
 * Сервисы хаба «Помощник». Сетка рассчитана на рост: новый инструмент — это
 * одна запись здесь, вёрстку править не нужно.
 *
 * Калькулятор пересчёта рецепта сюда не вынесен намеренно: он берёт
 * ингредиенты из открытой карточки и без неё показывает пустой экран, поэтому
 * живёт кнопкой внутри рецепта.
 */
export const ASSISTANT_SERVICES: readonly AssistantService[] = [
  {
    id: 'cost-calculator',
    label: 'Себестоимость',
    icon: 'solar:calculator-minimalistic-bold',
    path: ROUTES.COST_CALCULATOR,
    color: 'linear-gradient(150deg, #7aa9c7, #5f8fae)',
  },
]
